import { render, staticRenderFns } from "./MusicWave.vue?vue&type=template&id=342282f0&scoped=true&"
import script from "./MusicWave.vue?vue&type=script&lang=js&"
export * from "./MusicWave.vue?vue&type=script&lang=js&"
import style0 from "./MusicWave.vue?vue&type=style&index=0&id=342282f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342282f0",
  null
  
)

export default component.exports